var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { PaletteRGB, StandardLuminance, SwatchRGB, accentPalette, baseLayerLuminance } from "@fluentui/web-components";
import { parseColorHexRGB } from "@microsoft/fast-colors";
import { attr, observable } from "@microsoft/fast-element";
import { FoundationElement } from "@microsoft/fast-foundation";
import { Measures } from "../../../../../telemetry/Measures";
import { dashboard } from "../../../../../telemetry/TraceLogging";
import { getHostThemeApi } from "../../../../externalApi/ThemeApi";
import { getResources } from "../../../../getResources";
import { getWidgetOrchestrator } from "../../../../widgetRuntime/orchestrator/orchestrator";
export class ErrorCard extends FoundationElement {
    constructor() {
        super(...arguments);
        this.resources = getResources();
        this.retry = async () => {
            Measures.logEvent(dashboard, "WidgetReloadClicked", 33554432 /* productAndServiceUsage */, {
                appId: this.widgetInstance.widgetRegistration.appId,
                indexedDBInstanceId: this.widgetInstance.instanceId,
                providerId: this.widgetInstance.widgetRegistration.providerId,
                widgetDefinitionId: this.widgetInstance.widgetRegistration.id,
                widgetInstanceId: this.widgetInstance.widgetId,
            });
            let orchestrator = await getWidgetOrchestrator();
            // Reload any failed pined widgets
            orchestrator.reloadFailedWidgets(null);
            // Reload the specific widget if it is in the river
            orchestrator.reloadFailedWidgetsInDynamicFeed(this.widgetInstance);
        };
    }
    connectedCallback() {
        super.connectedCallback();
        //Handle theme information from the host as properties on the fast error card.
        let themeApiPromise = getHostThemeApi();
        themeApiPromise.then(async (themeApi) => {
            if (themeApi) {
                themeApi.addEventListener("themechanged", async () => {
                    await this.setThemeAccentColor(themeApi);
                });
                await this.setThemeAccentColor(themeApi);
            }
        });
    }
    async setThemeAccentColor(themeApi) {
        let colorpair = await themeApi.getBasicThemeColorPair();
        accentPalette.setValueFor(this.reloadButton, PaletteRGB.from(SwatchRGB.from(parseColorHexRGB(`#${colorpair.split(";")[1]}`))));
        baseLayerLuminance.setValueFor(this.reloadButton, colorpair.split(";")[0] == "000000" ? StandardLuminance.DarkMode : StandardLuminance.LightMode);
    }
}
__decorate([
    attr,
    __metadata("design:type", Object)
], ErrorCard.prototype, "resources", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ErrorCard.prototype, "widgetInstance", void 0);
